<template>
  <router-view />

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import LoadingBs5 from "@/components/frontend/LoadingBs5";

export default {
  name: "App",
  components: {
    LoadingBs5,
  },
  watch: {
    $route(to) {
      document.title = to.meta.title;
    },
  },
  data() {
    return {
      Loading: false,
      AccessToken: '',
      AGENTCODE: '',
    };
  },
  created() {

  },
  mounted() {
    // this.$router.push(
    //   `/?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGFpbTEiOiJCNzBUMk1CWnNFdTgwVlRMSkxnKzl3PT0ifQ.bwH3aV39lyoMC0JczJflZre6xkHf65BTgQuaFXorM1Y`
    // );
  },
};
</script>
<style></style>
